import { AdCreditOrder } from "./AdCredit";
import { ICrud } from "./common";
import { IInvoice } from "./Invoice";
import { IPackage } from "./Package";
import { IUserData } from "./Users";

export enum EXeroPaymentStatus {
  PENDING = "PENDING",
  SUCCEED = "SUCCEED",
  FAILED = "FAILED",
  INIT = "INIT",
  IN_PROGRESS = "IN_PROGRESS",
  VOIDED = "VOIDED",
}

export enum EActionMethod {
  APPROVED = "Approved",
  REJECTED = "Rejected",
}

export enum EXeroPaymentType {
  PACKAGE = "PACKAGE",
  AD_CREDIT = "AD_CREDIT",
}

export interface IXeroPaymentHistory extends ICrud {
  description: string | null;
  discountPrice: number | null;
  originPrice: number | null;
  packageId: string;
  paid: number | null;
  paymentUrl: string | null;
  status: EXeroPaymentStatus;
  total: number | null;
  totalDue: number | null;
  totalTax: number | null;
  userId: string;
  voucherId: string | null;
  xeroInvoiceID: string | null;
  xeroPaymentID: string | null;
  xeroPaymentId: string | null;
  xeroPaymentType: EXeroPaymentType;
}

export interface IXeroPayment extends ICrud {
  userId: string;
  packageId: string;
  adCreditOrderId: string | null;
  adCreditOrder?: AdCreditOrder;
  invoiceId?: string | null;
  onlineInvoiceUrl?: string | null;
  xeroInvoiceID?: string | null;
  status: EXeroPaymentStatus;
  type: EXeroPaymentType;

  user?: IUserData | null;
  package?: IPackage | null;
  invoice?: IInvoice | null;

  xeroPaymentHistories?: IXeroPaymentHistory[] | null;
  assetId?: string;
}

export interface IUpdateAssetXeroPayment {
  xeroPaymentId: string;
  assetId: string;
}

export interface IUserPayment {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
  email: string;
  status: string;
  role: string;
  firstName: string;
  lastName: string;
  phone: string;
  whatsapp: null;
  resetPasswordToken: null;
  measuringId: null;
  photoId: null;
  agencyLogoId: null;
  company: null;
  additionalEmail: null;
  ownerId: null;
  changePasswordLogMessage: null;
  isFlowSignUp: boolean;
  pricingPlans: string;
  statusAccount: string;
  adRerportUrl: string;
  note: null;
}

export interface IASSET_PAYMENT {
  urls: {
    url: string;
    width: number;
  }[];
}

export interface IItemPayment {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
  userId: string;
  packageId: string;
  invoiceId: string;
  paymentUrl: string;
  onlineInvoiceUrl: string;
  xeroInvoiceID: string;
  status: string;
  voucherId: null;
  type: string;
  user: IUserPayment;
  asset: IASSET_PAYMENT | null;
}

export interface IPayment {
  items: IItemPayment[];
  total: number;
  totalPage: number;
  currentPage: number;
  limit: number;
}

export interface IItemsHistory {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
  description: null | string;
  xeroPaymentId: string;
  xeroPaymentID: null | string;
  userId: string;
  packageId: string;
  paymentUrl: string | null;
  onlineInvoiceUrl: null | string;
  xeroInvoiceID: null | string;
  status: string;
  voucherId: null | string;
  xeroPaymentType: string;
  originPrice: null | string;
  discountPrice: null | string;
  totalTax: null | string;
  total: null | string;
  paid: null | string;
  totalDue: null | string;
}

export interface IPaymentHistory {
  items: IItemsHistory[];
  total: number;
  totalPage: number | null;
}

export enum EStatusPayment {
  "Pending" = "PENDING",
  "Succeed" = "SUCCEED",
  "Failed" = "FAILED",
  "Init" = "INIT",
  "In Progress" = "IN_PROGRESS",
  "Voided" = "VOIDED",
}

export enum EXeroPaymentMethod {
  PAY_NOW = "PAY_NOW",
  CREDIT_CARD = "CREDIT_CARD",
}
